/** Join class names, skipping falsy values (CSS-module lookups may be undefined in tests). */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}
